/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Closesidebar1Inputs */

const en_closesidebar1 = /** @type {(inputs: Closesidebar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close sidebar`)
};

const de_closesidebar1 = /** @type {(inputs: Closesidebar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenleiste schließen`)
};

/**
* | output |
* | --- |
* | "Close sidebar" |
*
* @param {Closesidebar1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const closesidebar1 = /** @type {((inputs?: Closesidebar1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closesidebar1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_closesidebar1(inputs)
	return de_closesidebar1(inputs)
});
export { closesidebar1 as "closeSidebar" }